import axios from 'axios'

axios.defaults.withCredentials = true


const actions = {
  get_CoopSavingsProtect_current_MCR({rootGetters}, data) {
    axios.defaults.baseURL = rootGetters['system_data/url']
    return new Promise((resolve, reject) => {
      axios.post('api/get_CoopSavingsProtect_current_MCR', data)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

export default {
  namespaced: true,
  actions,
}
